import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '60vh', padding: '2rem',
          gap: '1.5rem', textAlign: 'center',
        }}>
          <div style={{ fontSize: '3rem' }}>😕</div>
          <p style={{ fontFamily: 'var(--font-display)', color: 'var(--parch)', fontSize: '1.1rem' }}>
            Oups, quelque chose s'est mal passé
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Réessayer
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
